// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { MachineState } from '../_reducers/machine.reducers';
import { Machine, MachineTechType, MachineType } from '../_models/machine.model';

export const selectMachinesState = createFeatureSelector<MachineState>('machines');

export const selectMachineById = (machineId: number) => createSelector(
    selectMachinesState,
    machinesState => machinesState.entities[machineId]
);

export const selectMachinesPageLoading = createSelector(
    selectMachinesState,
    machinesState => machinesState.listLoading
);

// export const selectProductsActionLoading = createSelector(
//     selectMachinesState,
//     customersState => customersState.actionsloading
// );

export const selectMachinesPageLastQuery = createSelector(
    selectMachinesState,
    machinesState => machinesState.lastQuery
);

export const selectLastCreatedMachineId = createSelector(
    selectMachinesState,
    machinesState => machinesState.lastCreatedMachineId
);

export const selectLastUpdatedMachineId = createSelector(
    selectMachinesState,
    machinesState => machinesState.lastUpdatedMachineId
);

export const selectLastDeletedMachineId = createSelector(
    selectMachinesState,
    machinesState => machinesState.lastDeletedMachineId
);

export const selectMachinesInitWaitingMessage = createSelector(
    selectMachinesState,
    machinesState => machinesState.showInitWaitingMessage
);

export const selectMachinesInStore = createSelector(
    selectMachinesState,
    machinesState => {
        const items: Machine[] = [];
        each(machinesState.entities, element => {
            items.push(element);
        });
        const httpExtension = new HttpExtenstionsModel();
        const result: Machine[] = httpExtension.sortArray(items, machinesState.lastQuery.sortField, machinesState.lastQuery.sortOrder);
        return new QueryResultsModel(result, machinesState.totalCount, '');
    }
);

export const selectHasMachinesInStore = createSelector(
    selectMachinesInStore,
    queryResult => {
        if (!queryResult.totalCount) {
            return false;
        }

        return true;
    }
);

//MACHINE TYPES
export const selectMachineTypesState = state => state.machineTypes;

export const machineTypesLoaded = createSelector(
    selectMachineTypesState,
    machineTypesState => machineTypesState.machineTypesLoaded
)

export const selectMachineTypes = createSelector(
    selectMachineTypesState,
    machineTypesState => {
        const items: MachineType[] = [];
        each(machineTypesState.machineTypes, element => {
            items.push(element);
        });
        return items;
    }
)

//MACHINE TECH TYPES
export const selectMachineTechTypesState = state => state.machineTechTypes;

export const machineTechTypesLoaded = createSelector(
    selectMachineTechTypesState,
    machineTechTypesState => machineTechTypesState.machineTechTypesLoaded
)

export const selectMachineTechTypes = createSelector(
    selectMachineTechTypesState,
    machineTechTypesState => {
        const items: MachineTechType[] = [];
        each(machineTechTypesState.machineTechTypes, element => {
            items.push(element);
        });
        return items;
    }
)